import type * as React from 'react';

function SvgInfoCircle(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg fill="none" height="1em" viewBox="0 0 24 24" width="1em" {...props}>
      <path
        d="M12 2C6.4863 2 2 6.4858 2 12C2 17.5142 6.4863 22 12 22C17.5137 22 22 17.5142 22 12C22 6.4858 17.5137 2 12 2ZM12 20C7.5889 20 4 16.4111 4 12C4 7.5889 7.5889 4 12 4C16.4111 4 20 7.5889 20 12C20 16.4111 16.4111 20 12 20Z"
        fill="currentColor"
      />
      <path d="M12.9794 9.81979H11.0273V17.0576H12.9794V9.81979Z" fill="currentColor" />
      <path d="M12.9942 6.9424H11.0059V8.7837H12.9942V6.9424Z" fill="currentColor" />
    </svg>
  );
}

export default SvgInfoCircle;
